import { isNil } from 'ramda';

import { GetEpAgreementWallContextQuery } from '../../../graphql/queries/getEpAgreementWallContext.gql';

export const getIsComplianceDone = (
  moduleData: GetEpAgreementWallContextQuery,
) => {
  return (
    !isNil(moduleData.viewer.profile.isSpecifiedUSPerson) &&
    !isNil(moduleData.viewer.profile.hasForeignFiscalResidence)
  );
};
